// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"home_mainContainer__KmL78"};